export default __webpack_public_path__ + "static/media/arrow_select.3e74892a.svg";